import config from 'config'

import { isCmdClickEvent } from './event'

type Options = Partial<{
  openInNewTab: boolean
}>

export const openExternalURL = <T>(
  path: string,
  event?: React.MouseEvent<T> | null,
  options?: Options
) => {
  if (options?.openInNewTab || (event && isCmdClickEvent(event))) {
    window.open(path, '_blank')
  } else if (path.startsWith('http')) {
    window.location.href = path
  } else {
    window.location.pathname = path
  }
}

export const openInternalURL = <T>(
  path: string,
  history,
  event: React.MouseEvent<T> | null = null,
  options?: Options
) => {
  if (options?.openInNewTab || (event && isCmdClickEvent(event))) {
    window.open(config.APP_ROOT + path, '_blank')
  } else {
    history.push(path)
  }
}
